<div mat-dialog-title
     class="title">
    <div class="subtitle">{{ formTitle | translate }}</div>
    <div class="subinfo">{{ 'Weekly_repetition' | translate }}</div>
    <button mat-icon-button
            mat-dialog-close
            tabindex="-1"
            [matTooltip]="'Close' | translate"
            class="close-button hidden">
        <mat-icon>close</mat-icon>
    </button>
</div>
<div>
    <mat-dialog-content>
        <div class="line">
            <mat-form-field color="accent"
                            [hintLabel]="'date_format_hint' | translate">
                <input matInput
                       #endDateInput
                       [formControl]="endDateFormControl"
                       [min]="endDateMinDate"
                       [matDatepicker]="picker"
                       [placeholder]="'End_date' | translate">
                <mat-error *ngIf="endDateFormControl.hasError('required')">{{ 'Field_required' | translate }}</mat-error>
                <mat-error *ngIf="endDateFormControl.hasError('matDatepickerMin')">{{ 'Error_min_date_x' | translate:{minDate: (utilsProvider.DateToYmdHis(endDateMinDate) | dateClosest:'FjY')} }}</mat-error>
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker>
                </mat-datepicker>
            </mat-form-field>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions>
        <button mat-button
                mat-dialog-close
                tabindex="-1">
            {{ 'Cancel' | translate}}
        </button>
        <button mat-raised-button
                (click)="onChooseClicked()"
                color="accent">
            {{ confirmButtonTitle | translate}}
        </button>
    </mat-dialog-actions>
</div>

<div class="progress-container">
    <mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>
</div>
